import { Outlet } from "@remix-run/react";
import { QuizProvider } from "~/hooks/useQuizState";


export default function QuizLayout() {
  return (
    <QuizProvider>
      <Outlet />
    </QuizProvider>
  );
}
